import { render, staticRenderFns } from "./SalInvoiceList.vue?vue&type=template&id=70b6845b&scoped=true&"
import script from "./SalInvoiceList.vue?vue&type=script&lang=js&"
export * from "./SalInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./SalInvoiceList.vue?vue&type=style&index=0&id=70b6845b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6845b",
  null
  
)

export default component.exports